import { render, staticRenderFns } from "./BuyerInfo.vue?vue&type=template&id=1a29a61d&scoped=true&"
import script from "./BuyerInfo.vue?vue&type=script&lang=js&"
export * from "./BuyerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a29a61d",
  null
  
)

export default component.exports